import InsertBarcodeModal from './InsertBarcodeModal'

export default InsertBarcodeModal
